import { RouteConfig } from "@abaco/web-common/src/app";

const isColdiretti = (environment?: string) => {
    return environment === "coldiretti-demo";
};

export function createRouter(loginPage: string, useApiGw?: boolean, environment?: string): RouteConfig[] {
    let loginRoute: RouteConfig = {
        name: "login",
        path: "/login",
        component: () => import("../components/HomeLogin.vue"),
        props: (route) => {
            return Object.keys(route.params).length === 0 ? { initPage: loginPage } : route.params;
        },
        meta: { guest: true },
    };
    if (useApiGw) {
        loginRoute = {
            name: "login",
            path: "/login",
            component: () => import("../components/ExternalLogin.vue"),
            props: (route) => {
                return Object.keys(route.params).length === 0 ? { initPage: loginPage } : route.params;
            },
            meta: { guest: true },
        };
    }
    const loginCompatRoute: RouteConfig = {
        name: "login-compat",
        path: "/login-compat",
        component: () => import("../components/HomeLogin.vue"),
        props: (route) => {
            return Object.keys(route.params).length === 0 ? { initPage: loginPage } : route.params;
        },
        meta: { guest: true },
    };

    return [
        // {
        //     path: "/test",
        //     component: () => import("../components/Test.vue"),
        // },
        loginRoute,
        loginCompatRoute,
        {
            name: "registerSuccess",
            path: "/registerSuccess",
            component: () => import("../components/HomeLogin.vue"),
            props: (route) => {
                return { initPage: "register-success", ...route.query };
            },
            meta: { guest: true },
        },
        {
            name: "forgotPwdValidation",
            path: "/forgotPwdValidation/:requestId/:userId/:lang/:environment",
            component: () => import("../components/HomeLogin.vue"),
            props: (route) => {
                return { initPage: "forgot-password-check", ...route.params };
            },
            meta: { guest: true },
        },
        {
            name: "register",
            path: "/register",
            component: () => import("../components/HomeLogin.vue"),
            props: (route) => {
                return {
                    initPage: isColdiretti(environment) ? "coldiretti-demo-register-page" : "register-page",
                    ...route.params,
                };
            },
            meta: { guest: true },
        },
    ];
}
